import { render, staticRenderFns } from "./SingleWhitelist.vue?vue&type=template&id=34d79a62"
import script from "./SingleWhitelist.vue?vue&type=script&lang=js"
export * from "./SingleWhitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports